import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=0f7a6535&scoped=true"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"
import style0 from "./Feed.vue?vue&type=style&index=0&id=0f7a6535&prod&lang=scss&scoped=true"
import style1 from "./Feed.vue?vue&type=style&index=1&id=0f7a6535&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7a6535",
  null
  
)

export default component.exports